export default {
  isMenuVisible: state => {
    return state.menuVisible;
  },
  loadingOverlay: state => {
    return state.loadingOverlay;
  },
  feedback: state => {
    return state.feedback;
  },
  automationRunDelayOptions: state => {
    return state.automationRunDelayOptions;
  },
  windowSizes: state => {
    return state.windowSizes;
  },
  automationsAdvancedView: state => {
    return state.automationsAdvancedView;
  },
  automationsAdvancedViewChanged: state => {
    return state.automationsAdvancedViewChanged;
  },
  cameraSmallViewSnapshotInterval: state => {
    return state.cameraSmallViewSnapshotInterval;
  },
  cameraViewSnapshotInterval: state => {
    return state.cameraViewSnapshotInterval;
  },
  isDark: state => {
    return state.isDark;
  },
  screenType: state => {
    const {width} = state.windowSizes;

    if (width > 1280) {
      return 'desktop large';
    } else if (width > 1024) {
      return 'desktop';
    } else if (width > 768) {
      return 'tablet large';
    } else if (width > 425) {
      return 'tablet';
    } else if (width > 375) {
      return 'mobile large';
    } else if (width > 320) {
      return 'mobile medium';
    }

    return 'mobile small';
  },
  clientFingerprint: state => {
    return state.clientFingerprint;
  },
  usageId: state => {
    return state.usageId;
  },
  initializing: state => {
    return state.initalizing;
  },
  backendError: state => {
    return state.backendError;
  },
  googleMapsBaseUrl: state => {
    return state.googleMapsBaseUrl;
  },
  googleMapsApiKey: state => {
    return state.googleMapsApiKey;
  },
  googleMapsLibLoaded: state => {
    return state.googleMapsLibLoaded;
  },
  geolocationSupported: state => {
    return state.geolocationSupported;
  },
  geolocation: state => {
    return state.geolocation;
  },
  isMobileUserAgent: state => {
    return state.isMobileUserAgent;
  },
  engineInitTimestamp: state => {
    return state.system ? state.system.engine.initTimestamp : 0;
  },
  engineRestarts: state => {
    return state.system ? state.system.engine.restarts : [];
  },
  versions: state => {
    return state.versions;
  }
};
